export const url_resume_pdf_github =
  "https://github.com/cw1997/resume/releases/download/latest/changwei-resume.pdf"
export const url_resume_pdf_github_english =
  "https://github.com/cw1997/resume/releases/download/latest/changwei-resume-english.pdf"
export const url_resume_pdf_release =
  "https://github.com/cw1997/resume/releases"
export const url_resume_pdf_mirror = "/api/changwei-resume-pdf"
export const url_resume_pdf_source = "https://github.com/cw1997/resume"
